import { Card, CardBody, Col, Row } from "reactstrap";
import { Btn, H4, LI, UL } from "../../../../AbstractElements";
import { BecomeMembers, Href, SignUp } from "../../../../Constants/Constants";
import { BecomeMemberData } from "../../../../Data/Applications/ECommerce/ECommerce";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";

const BecomeMember = () => {
  return (
    <Card>
      <CommonCardHeader title={BecomeMembers} />
      <CardBody className="pricing-col gy-4">
        <Row>
          {BecomeMemberData.map((item, index) => (
            <Col lg="3" sm="6" key={index}>
              <div className="pricingtable">
                <div className="pricingtable-header">
                  <H4 className="title">{item.type}</H4>
                </div>
                <div className="price-value">
                  <span className="currency">$</span>
                  <span className="amount">{item.price}</span>
                  <span className="duration">/mo</span>
                </div>
                <UL className="pricing-content simple-list flex-row">
                  {item.benefit.map((data, index) => (
                    <LI key={index}>{data}</LI>
                  ))}
                </UL>
                <div className="pricingtable-signup">
                  <Btn tag="a" size="lg" color="primary" href={Href}>{SignUp}</Btn>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </CardBody>
    </Card>
  );
};

export default BecomeMember;
